import classnames from 'classnames';
import compact from 'lodash/compact';
import { arrayOf, bool, func, number, shape } from 'prop-types';
import React from 'react';
import { Alert, Col, FormGroup, Label, Row, Table } from 'reactstrap';

import LanguageHeaderLine from '../../campaign-editor/CampaignLineTable/LanguageHeaderLine';
import LanguageIndependentCampaignLine from '../../campaign-editor/CampaignLineTable/LanguageIndependentCampaignLine';
import LanguageLine from '../../campaign-editor/CampaignLineTable/LanguageLine';
import CurrencyInput from '../../generic/CurrencyInput';
import Loading from '../../generic/Loading';
import { isCountdown } from '../../products/utils';
import { campaignLineShape } from '../../prop-types';
import api from '../../REST/api';

class NewCampaignLineForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.state = { errorMessage: '', loadingConfig: false };
  }

  componentDidMount() {
    this.getDefaultConfigs();
  }

  handleChange(event) {
    this.props.onChange(event);
  }

  async getDefaultConfigs() {
    this.setState({ loadingConfig: true });
    const { configQueries, line, onChange, index } = this.props;
    const configResponse = await api
      .getDefaultProductFields({
        ...configQueries,
        countryCode: line.country.code,
        gender: line.gender,
      })
      .catch(err => {
        if (err) {
          this.setState({
            errorMessage: 'No default text content copy',
          });
        }
        this.setState({ loadingConfig: false });
      });

    const responseFields = configResponse
      ? {
          languages: compact([
            configResponse.language1,
            configResponse.language2,
            configResponse.language3,
            configResponse.language4,
          ]),
          ...configResponse,
        }
      : {};

    onChange({
      target: {
        name: index,
        value: {
          ...this.props.line, // in case the line has changed in the meantime
          ...responseFields,
        },
      },
    });
  }

  render() {
    const { line, index, showCountryHeader, onToggleSelection, onIsSelected } =
      this.props;
    const headerClass = classnames('p-3 rounded bg-light mb-3');
    const countdown = isCountdown({ code: line.product.code });
    const { loadingConfig, errorMessage } = this.state;
    return (
      <FormGroup className={headerClass}>
        {line.country && showCountryHeader && <h5>{line.country.name}</h5>}
        <Row>
          <Col sm={5} className="" key={index}>
            <FormGroup row>
              <input
                type="checkbox"
                checked={onIsSelected(index)}
                className="ml-3"
                onChange={() => onToggleSelection(`select-${index}`)}
              />
              <Col>
                <CurrencyInput
                  name={`${index}.netClientBudget`}
                  bsSize="md"
                  value={0}
                  readOnly
                />
                <Label className="mb-0 small text-muted">
                  Net Client budget
                </Label>
              </Col>
              <Col>
                <CurrencyInput
                  name={`${index}.coInvest`}
                  bsSize="md"
                  value={0}
                  readOnly
                />
                <Label className="mb-0 small text-muted">Co Invest</Label>
              </Col>
              <Col>
                <CurrencyInput
                  name={`${index}.freeService`}
                  bsSize="md"
                  value={0}
                  readOnly
                />
                <Label className="mb-0 small text-muted">Free Service</Label>
              </Col>
            </FormGroup>
          </Col>
          <Col sm={7} className="align-items-end">
            <LanguageIndependentCampaignLine
              label=""
              line={line}
              onChange={this.handleChange}
              index={index}
              readOnlyGender
            />
          </Col>
        </Row>
        <Row className="mt-2">
          {!line.languages && (
            <Col>
              {loadingConfig ? (
                <Loading />
              ) : (
                <Alert color="warning" className="mb-0">
                  <span>{errorMessage}</span>
                </Alert>
              )}
            </Col>
          )}
        </Row>
        <Row>
          {line.languages && !countdown && (
            <Table borderless className="mb-0 table-sm">
              <thead>
                <LanguageHeaderLine line={line} showActions={false} />
              </thead>
              <tbody>
                {line.languages.map((lang, idx) => (
                  <LanguageLine
                    key={lang}
                    line={line}
                    onChange={this.handleChange}
                    languageIndex={idx + 1}
                    index={index}
                    showActions={false}
                  />
                ))}
              </tbody>
            </Table>
          )}
        </Row>
      </FormGroup>
    );
  }
}

NewCampaignLineForm.propTypes = {
  onChange: func.isRequired,
  line: campaignLineShape.isRequired,
  index: number.isRequired,
  configQueries: shape({
    brandIds: arrayOf(number.isRequired),
    productId: number,
  }),
  showCountryHeader: bool,
  onToggleSelection: func.isRequired,
  onIsSelected: func.isRequired,
};

NewCampaignLineForm.defaultProps = {
  configQueries: {},
  showCountryHeader: false,
};

export default NewCampaignLineForm;
